import React, { useEffect, useRef } from "react";
import moment from "moment";
import { TYPE_HYBRID } from "../../../constants/common";
import replacePlaceholders from "../../../../../widgets/widgetRegistration/src/core/helpers/replacePlaceholders";

import './style.scss';

const InfoAuthentication = ({
    $locale,
    posterImage,
    eventName,
    eventTitle,
    hideEventTitle,
    eventSubtitle,
    hideEventSubtitle,
    date,
    eventTimeStart,
    eventTimeStop,
    hideDate,
    hideFormat,
    eventParticipationType,
    onWindowResize = () => {},
}) => {
    const posterRef = useRef();
    const [dateStart, timeStart] = moment.unix(eventTimeStart).format('LLL').split(', ');
    const [dateStop, timeStop] = moment.unix(eventTimeStop).format('LLL').split(', ');

    const placeholders = {
        eventName,
        dateStart,
        timeStart,
        dateStop,
        timeStop,
    };

    const title = eventTitle
        ? replacePlaceholders(eventTitle, placeholders)
        : '';
    const subtitle = eventSubtitle
        ? replacePlaceholders(eventSubtitle, placeholders)
        : '';
    const dateInformation = date
        ? replacePlaceholders(date, placeholders)
        : `${dateStart}, ${timeStart}`;

    const participationType = eventParticipationType === TYPE_HYBRID
        ? `${$locale.get('participationType.online')} + ${$locale.get('participationType.offline')}`
        : $locale.get(`participationType.${eventParticipationType}`);

    useEffect(() => {
        if (!posterRef.current) return;

        const resizeObserver = new ResizeObserver(() => {
            onWindowResize();
        });

        resizeObserver.observe(posterRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <div className="auth-info-block">
            {((!hideEventTitle && title) || (!hideEventSubtitle && eventSubtitle)) && (
                <div className="auth-info-block__container">
                    {(!hideEventTitle && title) && (
                        <h1>{title}</h1>
                    )}
                    {(!hideEventSubtitle && subtitle) && (
                        <p className="auth-info-block__text subtitle">{subtitle}</p>
                    )}
                </div>
            )}
            {posterImage && (
                <div className="auth-info-block__poster-container">
                    <img
                        ref={posterRef}
                        src={posterImage}
                        alt=""
                        className="auth-info-block__poster-image"
                    />
                </div>
            )}
            {(!hideDate || !hideFormat) && (
                <div>
                    {(!hideDate && dateInformation) && (
                        <p className="auth-info-block__text">
                            {dateInformation}
                        </p>
                    )}
                    {!hideFormat && (
                        <p className="auth-info-block__text">
                            {participationType}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default InfoAuthentication;
